export type { AttributeType } from './HistoryTable';
export { HistoryTable } from './HistoryTable';
